import axios from 'axios';

export default payload => {
  let uri = process.env.REACT_APP_APOLLO_API_URL || 'https://service-transactional.develop.embrix.org/graphql';
  if (window._env_ && window._env_.REACT_APP_APOLLO_API_URL) {
    uri = window._env_.REACT_APP_APOLLO_API_URL;
  }
  return axios.post(uri, payload);
};
